module.exports = __webpack_public_path__ + "static/media/in.bd83f348.svg";